import { ColDef, GridReadyEvent } from 'ag-grid-community';

import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { Config } from 'src/app/app-constant';
import { Location } from '@angular/common';
import { HttpService } from 'src/app/service/http/http.service';
import { SharedService } from 'src/app/service/shared/shared.service';

import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { RowStyle } from 'ag-grid-community';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
@Component({
  selector: 'app-grid-table',
  templateUrl: './grid-table.component.html',
  styleUrls: ['./grid-table.component.scss']
})
export class GridTableComponent implements OnInit {
  @Input() gridData: any;
  @Input() isChangeDetected: boolean = false;
  @Input() TableName: string = '';
  @Input() paginationUrl: string = '';
  @Input() selectedRange: number = 10;
  @Input() searchText: string = '';
  @Input() selectedTypeTabIndex: any = 0;
  paginationPageSize = 10; // default page size
  paginationPageSizeSelector = [10, 25, 50, 75, 100, 200, 500];

  gridApi: any;
  gridColumnApi: any;
  // ✅ Outputs

  @Output() refreshDataEmmiter = new EventEmitter<void>();
  @Output() showNumberOfRecordsEmmiter = new EventEmitter<number>();
  @Output() deleteDetailEmmiter = new EventEmitter<any>();
  @Output() deleteMultipleRecordsEmmiter = new EventEmitter<any[]>();
  @Output() searchDataEmitter = new EventEmitter<string>();
  @Output() exportEmmiter = new EventEmitter<any>();
  @Output() emmitPagination = new EventEmitter<any>();
  @Output() addRecordEmmiter = new EventEmitter<void>();
  @Output() unlinkDeviceEmmiter = new EventEmitter<any>();
  @Output() editDetailEmmiter = new EventEmitter<any>();
  @Output() LoginDetailEmmiter = new EventEmitter<any>();
  @Output() detailsEmmiter = new EventEmitter<any>();
  @Output() sortAsendingEmmiter = new EventEmitter<string>();
  @Output() sortDesendingEmmiter = new EventEmitter<string>();
  @Output() paginationDataEmmiter = new EventEmitter<any>();
  @Output() typeTabEmmiter = new EventEmitter<string>();
  @Output() importFileEmmiter = new EventEmitter<void>();
  @Output() backbtnEmmiter = new EventEmitter<any>();
  // ✅ Grid state
  columnDefs: ColDef[] = [];
  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true
  };
  selectedRow: any = null;
  isDetailsOpen: boolean = false;
  loggedInUserCompanyID: any;
  buttonColorName: any;
  subModuleButtonColor: any;
  employeeIdOfMD: any = null;
  collapseSidebar: boolean = false;
  constructor(
    private httpService: HttpService,
    private config: Config,
    private datePipe: DatePipe,
    public fb: FormBuilder,
    public router: Router,
    private location: Location,
    private sharedService: SharedService,
    public dialog: MatDialog,
    private encryptionService: EncryptionService
  ) {}
  ngOnInit() {
    if (this.employeeIdOfMD == null) {
      this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
      if (this.router.url.includes('employeemaster')) {
        this.getCompanyDataByCompID();
      }
    }
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.collapseSidebar = this.sharedService.getBooleanValue();
  }

  // --------------------------------------------- Start Row Style---------------------------------------------------------------

  getRowClass = (params: any) => {
    if (params.data?.linkName === this.employeeIdOfMD) {
      return 'row-selected'; // 🔹 special highlight class
    }
    return;
    // return params.node.rowIndex % 2 === 0 ? 'row-even' : 'row-odd';
  };

  // ----------------------------------------------------------End Row Style---------------------------------------------------------------

  // -------------------------------------------------------------- Start side bar Enable Disabled-----------------------------------------------------
  onRowClickedForEmployee(event: any) {
    this.selectedRow = event.data;
    if (event.colDef?.headerName === 'Action' || event.colDef?.headerName === 'Device') {
      this.isDetailsOpen = false;
    } else if (event.colDef?.headerName === 'Emp ID') {
      this.isDetailsOpen = false;
      this.detailsEmmiter.emit(event.data);
    } else {
      this.isDetailsOpen = true;
    }
  }
  // -------------------------------------------------------------- End side bar Enable Disabled-----------------------------------------------------
  getCompanyDataByCompID() {
    this.httpService.callGetService(this.config.getCompanyDataByCompID + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.employeeIdOfMD = data?.data?.employeeIdOfMD;
    });
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    // Listen for page changes (optional)
    this.gridApi.addEventListener('paginationChanged', this.onPaginationChanged.bind(this));

    // Auto-size columns
    setTimeout(() => {
      if (!this.gridColumnApi) return;

      const allColIds: string[] = [];
      this.gridColumnApi.getAllColumns()?.forEach((col: { getColId: () => string }) => allColIds.push(col.getColId()));

      if (allColIds.length) {
        this.gridColumnApi.autoSizeColumns(allColIds);
        this.gridApi.sizeColumnsToFit();
      }
    });
  }

  onPaginationChanged() {
    const currentPageSize = this.gridApi.paginationGetPageSize();

    // Call your method only if page size changed
    if (currentPageSize !== this.paginationPageSize) {
      this.paginationPageSize = currentPageSize;
      this.onSelectCount(currentPageSize);
    }
  }
  electedDate: any = moment();
  renderData: Array<any> = [];
  selectAllCheckbox: boolean = false;
  mulipleSelect: any = [];
  showDelete: boolean = false;
  deltetedDatacount: number = 0;
  selectSingleRecord(event: any, data: any, i: number) {
    if (event.checked) {
      this.showDelete = true;
      this.renderData[i].checkboxCheck = true;
      this.deltetedDatacount++;
      this.mulipleSelect.push(data);
    } else {
      this.showDelete = false;
      this.renderData[i].checkboxCheck = false;
      this.deltetedDatacount--;
      this.mulipleSelect.forEach((ele: any, ind: any) => {
        if (ele.checkboxCheck == false) {
          this.mulipleSelect.splice(ind, 1);
        }
      });
      if (this.deltetedDatacount == 0) {
        this.mulipleSelect = [];
      }
      this.selectAllCheckbox = false;
    }
  }
  LoginDetail(data: any) {
    this.LoginDetailEmmiter.emit(data);
  }
  onSelectionChanged() {
    this.mulipleSelect = this.gridApi.getSelectedRows();
    this.showDelete = this.mulipleSelect.length > 0;
  }
  deleteMultipleRecords() {
    this.deleteMultipleRecordsEmmiter.emit(this.mulipleSelect);
  }
  backBtn() {
    this.backbtnEmmiter.emit();
    // this.location.back()
  }
  addRecord() {
    this.addRecordEmmiter.emit();
  }
  exportReport() {
    this.exportEmmiter.emit(this.mulipleSelect);
  }
  importReport() {
    this.importFileEmmiter.emit();
  }
  tabTypeChanged(event: any) {
    this.typeTabEmmiter.emit(event);
  }
  previousFetchCount = 25; // default fetch
  onSelectCount(fetchCount: number) {
    if (fetchCount !== this.previousFetchCount) {
      this.previousFetchCount = fetchCount;

      // Emit value to parent
      this.showNumberOfRecordsEmmiter.emit(fetchCount);

      // Optional: reset grid to first page
      if (this.gridApi) {
        this.gridApi.paginationGoToFirstPage();
      }
    }
  }
  // ✅ Events mapping
  onRowClicked(event: any) {
    this.selectedRow = event.data;
    console.log('event.data', event.data);
    this.detailsEmmiter.emit(event.data);
  }
  onSearch() {
    this.searchDataEmitter.emit(this.searchText);
  }
  closeDetails() {
    this.isDetailsOpen = false;
  }

  unlinkDevice(data: any) {
    this.unlinkDeviceEmmiter.emit(data);
  }

  editDetail(data: any) {
    this.editDetailEmmiter.emit(data);
  }

  deleteEmployee(id: number) {
    this.deleteDetailEmmiter.emit(id);
  }

  getValue(row: any, field: string) {
    return row ? row[field] : '';
  }

  formatDate(dateStr: string) {
    return dateStr ? new Date(dateStr).toLocaleDateString() : '';
  }
  onQuickFilter(event: any) {}
  onPageSizeChanged(event: any) {
    this.gridApi.paginationSetPageSize(Number(event.value));
  }
  formatStatus(status: string) {
    return status ? status.toUpperCase() : '';
  }

  getStatusClass(row: any, field: string) {
    const value = this.getValue(row, field);
    return {
      'status-active': value === 'Active',
      'status-inactive': value === 'Inactive',
      'status-pending': value === 'Pending'
    };
  }
  isAddFlag: boolean = true;
  isEditFlag: boolean = true;
  isPerDeleteFlag: boolean = true;
  sidebarModule: any = [];
  // ngOnChanges(changes: SimpleChanges) {
  //   if (this.employeeIdOfMD == null) {
  //     this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
  //     if (this.router.url.includes('employeemaster')) {
  //       this.getCompanyDataByCompID();
  //     }
  //   }
  //   this.buttonColorName = sessionStorage.getItem('buttonColorName');
  //   this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
  //   this.collapseSidebar = this.sharedService.getBooleanValue();
  //   this.selectAllCheckbox = false;
  //   this.mulipleSelect = [];

  //   this.sidebarModule = JSON.parse(localStorage.getItem('pemissionModules')!);
  //   for (let i = 0; i < this.sidebarModule?.length; i++) {
  //     if (this.sidebarModule[i]?.routerName == this.router.url) {
  //       this.isAddFlag = this.sidebarModule[i]?.isAdd;
  //       this.isEditFlag = this.sidebarModule[i]?.isEdit;
  //       this.isPerDeleteFlag = this.sidebarModule[i]?.isPerDeleted;
  //     }
  //   }
  //   if (this.gridData?.columnInfo) {
  //     this.columnDefs = [
  //       {
  //         headerName: '',
  //         checkboxSelection: true,        // show checkbox in rows
  //         headerCheckboxSelection: true,  // show "select all" in header
  //         width: 50,
  //         minWidth: 50,
  //         maxWidth: 50,
  //         pinned: 'left',
  //         sortable: false,
  //         filter: false,
  //         resizable: false
  //       },
  //       ...this.gridData.columnInfo.map((col: any) => {
  //         const isFixedColumn = ['Emp ID', 'Status', 'Action', 'Device'].includes(col.label);

  //         const baseCol: any = {
  //           headerName: col.label,
  //           field: col.propertyName,
  //           autoHeight: true,
  //           width: isFixedColumn ? 130 : 150,
  //           minWidth: isFixedColumn ? 130 : 150,
  //           maxWidth: isFixedColumn ? 130 : null,
  //           resizable: !isFixedColumn,
  //           flex: isFixedColumn ? undefined : 1,
  //         };
  //         if (col.label === 'Emp ID') {
  //           baseCol.cellStyle = { color: '#143e8e', cursor: 'pointer' };
  //         }
  //         if(col.label === 'Device'){
  //           return{
  //             ...baseCol,
  //             sortable: false,
  //             filter: false,
  //             cellRenderer: (params:any) => {
  //               if(params?.value){
  //                 return `<div class="click-link mt-10"><ion-icon style="color:#143e8e;cursor:pointer;" class="unlink-device fs-22" name="unlink"></ion-icon></div>`;
  //               } else {
  //                 return `<div></div>`;
  //               }
  //             },
  //             onCellClicked: (params: any) => {
  //               const target = params.event.target as HTMLElement;
  //               if (target.classList.contains('unlink-device')) this.unlinkDevice(params.data);
  //             },
  //           }
  //         }
  //         if (col.label === 'Action') {
  //           return {
  //             ...baseCol,
  //             sortable: false,
  //             filter: false,
  //             cellRenderer: () => {
  //               return `
  //               <div style="display:flex;align-items:center;gap:10px;cursor:pointer">
  //               <img class="edit-btn" class="mr-5 cp imgdelete" src="././assets/icon/edit.png" style="width:20px;margin-top:10px">
  //               <img class="user-btn" class="mr-5 cp imgdelete" src="././assets/icon/user-login.png"style="width:20px;margin-top:10px">
  //               </div>`;
  //             },
  //             onCellClicked: (params: any) => {
  //               const target = params.event.target as HTMLElement;
  //               if (target.classList.contains('edit-btn')) this.editDetail(params.data);
  //               if (target.classList.contains('user-btn')) this.LoginDetail(params.data);
  //             },
  //           };
  //         }

  //         return baseCol;
  //       })
  //     ];

  //   }
  // }

  ngOnChanges(changes: SimpleChanges) {
    /* -------------------------------------------
     * Company + MD employee logic
     * ------------------------------------------- */
    if (this.employeeIdOfMD == null) {
      const companyId = sessionStorage.getItem('loggedInUserCompanyID');
      if (companyId) {
        this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(companyId));

        if (this.router.url.includes('employeemaster')) {
          this.getCompanyDataByCompID();
        }
      }
    }

    /* -------------------------------------------
     * UI / Theme / Sidebar states
     * ------------------------------------------- */
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.collapseSidebar = this.sharedService.getBooleanValue();

    this.selectAllCheckbox = false;
    this.mulipleSelect = [];

    /* -------------------------------------------
     * Permission handling
     * ------------------------------------------- */
    const permissionModules = localStorage.getItem('pemissionModules');
    this.sidebarModule = permissionModules ? JSON.parse(permissionModules) : [];

    this.isAddFlag = true;
    this.isEditFlag = true;
    this.isPerDeleteFlag = true;

    for (let i = 0; i < this.sidebarModule.length; i++) {
      if (this.sidebarModule[i]?.routerName === this.router.url) {
        this.isAddFlag = this.sidebarModule[i]?.isAdd;
        this.isEditFlag = this.sidebarModule[i]?.isEdit;
        this.isPerDeleteFlag = this.sidebarModule[i]?.isPerDeleted;
        break;
      }
    }

    /* -------------------------------------------
     * AG Grid Column Definitions
     * ------------------------------------------- */
    if (!Array.isArray(this.gridData?.columnInfo)) {
      // ❗ prevents: Cannot read properties of null (reading 'map')
      return;
    }

    this.columnDefs = [
      {
        headerName: '',
        checkboxSelection: true,
        headerCheckboxSelection: true,
        width: 50,
        minWidth: 50,
        maxWidth: 50,
        pinned: 'left',
        sortable: false,
        filter: false,
        resizable: false
      },

      ...this.gridData.columnInfo.map((col: any) => {
        const isFixedColumn = ['Emp ID', 'Status', 'Action', 'Device'].includes(col.label);

        const baseCol: any = {
          headerName: col.label,
          field: col.propertyName,
          autoHeight: true,
          width: isFixedColumn ? 130 : 150,
          minWidth: isFixedColumn ? 130 : 150,
          maxWidth: isFixedColumn ? 130 : undefined,
          resizable: !isFixedColumn,
          flex: isFixedColumn ? undefined : 1
        };

        /* -------- Emp ID -------- */
        if (col.label === 'Emp ID') {
          baseCol.cellStyle = { color: '#143e8e', cursor: 'pointer' };
        }

        /* -------- Device -------- */
        if (col.label === 'Device') {
          return {
            ...baseCol,
            sortable: false,
            filter: false,
            cellRenderer: (params: any) =>
              params?.value
                ? `<ion-icon class="unlink-device fs-22"
                    style="color:#143e8e;cursor:pointer"
                    name="unlink"></ion-icon>`
                : '',
            onCellClicked: (params: any) => {
              const target = params.event?.target as HTMLElement;
              if (target?.classList.contains('unlink-device')) {
                this.unlinkDevice(params.data);
              }
            }
          };
        }

        /* -------- Action -------- */
        if (col.label === 'Action') {
          return {
            ...baseCol,
            sortable: false,
            filter: false,
            cellRenderer: () => `
            <div style="display:flex;align-items:center;gap:10px;cursor:pointer">
              <img class="edit-btn" src="././assets/icon/edit.png" width="20">
              <img class="user-btn" src="././assets/icon/user-login.png" width="20">
            </div>
          `,
            onCellClicked: (params: any) => {
              const target = params.event?.target as HTMLElement;
              if (target?.classList.contains('edit-btn')) {
                this.editDetail(params.data);
              }
              if (target?.classList.contains('user-btn')) {
                this.LoginDetail(params.data);
              }
            }
          };
        }

        return baseCol;
      })
    ];

    /* -------------------------------------------
     * Resize columns safely if grid already ready
     * ------------------------------------------- */
    setTimeout(() => {
      if (this.gridApi && this.gridColumnApi) {
        this.gridApi.sizeColumnsToFit();
      }
    });
  }

  isClicked = false;
  searchTaskString: string = '';
  // gridApi: any;
  resetGrid() {
    this.isClicked = true; // Trigger animation

    if (this.gridApi) {
      // if (this.isFinanceLoginUser) {
      //   this.getFinaceForReimbursement(-1);
      // }

      // this.financeIdForEmployee = -1;
      // ✅ Reset filters & sorting
      this.gridApi.setFilterModel(null);
      // this.gridApi.setSortModel(null);
      this.gridApi.deselectAll();

      // ✅ Reset quick filter (search box)
      this.searchTaskString = '';
      this.gridApi.setGridOption('quickFilterText', ''); // Clears quick filter text

      // ✅ Force refresh so UI input also clears
      this.gridApi.refreshCells();
      this.gridApi.resetColumnState(); // ✅ Reset columns
    }
  }
}
